import React from 'react';
import '../CSS/QuemsomosAboutus.css';
import backgroundImage from '../Images/fundo2.png';
import backgroundImageWebp from '../Images/fundo2.webp';
import logoAssinatura from '../Images/LogoStroke.png';

const Quemsomos = () => {
    
    return (
        <div>
            <picture>
                <source srcSet={backgroundImageWebp} type="image/webp" />
                <img src={backgroundImage} className='backImage2' alt="" loading="eager" decoding="async" />
            </picture>

            <div className="er-pageShell">
                <div className='divCenteredContent er-container'>
                <div className='divBigTitle'>
                    <h1 className='BigTitle'>Escape Room - Bragança</h1>
                </div>

                <p className='regularText'>Esta Escape Room foi feita com muito carinho por: ANDR3IA, C4RLOS, CRIS7IANO e F1LIPA. </p>
                <p className='regularText'>Somos uma equipa de entusiastas de escape rooms, e pretendemos que te tornes num também. Junta-te ao grupo!</p>

                <div className='div3Texts'>
                    <div>
                        <p className='textos3'>1. Encontra todas as pistas</p>
                    </div>

                    <div>
                        <p className='textos3'>2. Descobre como avançar nos enigmas</p>
                    </div>

                    <div>
                        <p className='textos3'>3. Tenta sair da sala o mais rápido possível</p>
                    </div>
                </div>

                <p className='regularText'>Queremos que todos consigam testar os próprios limites, independentemente da idade ou da língua que falam. 
                Contacta-nos para mais informações.</p>

                <p className='regularText'>Devido ao nível de dificuldade dos nossos desafios, recomendamos grupos de 2 a 4 pessoas. 
                No entanto, se te sentes confiante e queres pôr-te à prova, também o podes fazer sozinho!</p>

                <p className='regularTextYellow'>Traz os teus amigos e vem tentar escapar!</p>

                <div className='divAssinatura er-panel'>
                    <p>A equipa,</p>

                    <img src={logoAssinatura} className='logoImage' alt="" />
                </div>                
                </div>
            </div>
        </div>
    );
};

export default Quemsomos;